module.exports = __webpack_public_path__ + "static/img/2022_sponsor7_low.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022_sponsor7_low.png
// module id = EfmO
// module chunks = 0